import AmpService from "analytics/amplitude/amplitudeEvents";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import styles from "./generic-recommendation-card.module.scss";

const GenericRecommendationCard = ({ card }: { card: any }) => {
  const { loggedIn } = useSelector((state: RootState) => state.authenticationState);
  const selectedVehicle = useSelector((state: RootState) => state.garage.vehicles[0] ?? null);

  return (
    <div className={styles.cardItems}>
      {card.items.slice(0, 4).map((item, idx) => {
        const { href, asPath } = getHrefAndPath({ asPath: item.link });
        return (
          <Link
            key={idx}
            href={href}
            as={asPath}
            onClick={() => AmpService.homeRecommendationCardItemClicked({
              cardKey: card.key,
              itemLabel: item.label,
              itemLink: item.link,
              selectedVehicle,
              loggedIn,
            })}
          >
            <div className={styles.item}>
              <PAImage src={getRelativeImagePath(`/img/ds${item.img}`)} alt={item.label} width={100} height={100} className={styles.card_img} />
              <PAText
                component="p"
                fontSize={FONT_SIZE[0]}
                color="black"
                className={`p-t-5 m-b-0 ${styles.item_description}`}
              >
                {item.label}
              </PAText>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default GenericRecommendationCard;
